import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {Person, DataUser} from '../../interface/person.interface';
import {SelectTipo, SelectGeneric} from '../../interface/selectTipo.interface';
import {EmitResultInterface} from '../../interface/emitResult.interface';

import {TipoSelectService} from './../../services/tipoSelect.service';
import swal from 'sweetalert2';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbModalConfig, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClientInfoVO} from 'src/app/interface/client-info-vo.interface';
import {TipoDeUso} from 'src/app/interface/tipo-uso.interface';
import {ConsultaRFC} from 'src/app/interface/consultaRFC.interface';
import {ResponseString} from 'src/app/interface/response-string';
import {AppConfigService} from '../../app-config.service';
import {GeneraItuService} from '../../services/genera-itu.service';
import {IConsultCpByItu} from '../../interface/consultCpByItu.interface';
import {Itu} from '../../models/itu';
import {ValidaItuInterface} from '../../interface/array-itu.interface';
import {AddressService} from '../../services/address.service';
import {UserEmailService} from '../../services/userEmail.service';
import {CanComponentDeactivate} from '../../interface/can-component-deactivate.interface';

@Component({
    selector: 'app-form-invoice',
    templateUrl: './form-invoice.component.html',
    styleUrls: ['./form-invoice.component.css']
})
export class FormInvoiceComponent implements OnInit, CanComponentDeactivate {

    formDisabled = false;

    color = 'warn';
    colorTexto = '';
    classBtn = '';
    autoRenew1 = new FormControl();
    changeIeps = false;
    nocolony = false;
    autoRenew2 = new FormControl();
    extranjero = false;
    validForeingData = false;
    disabledSelect = false;
    disabledSelectPerson = false;
    tipouso: TipoDeUso;
    arrTipoUso: SelectTipo[] = [];
    arrRegimenFi: SelectTipo[] = [];

    // Formulario para recabar datos de Facturación
    formInvoice: FormGroup;
    enableBtnEdit = true;

    dataInvoice: DataUser;
    consultaRFC: ConsultaRFC;
    cpByItu: IConsultCpByItu;

    estados: SelectTipo[] = [];
    municipios: SelectTipo[] = [];
    colonias: SelectTipo[] = [];
    residenciasFiscales: SelectTipo[] = [];
    arrPerson: SelectTipo[] = [];

    enableForm = false;

    btnAvailable = false;

    rfc_l = sessionStorage.getItem('rfc');
    type_p_l = sessionStorage.getItem('type_person');
    uso_c_l = sessionStorage.getItem('uso_cfdi');
    reg_fis = sessionStorage.getItem('reg_fiscal');
    billingId = Number(sessionStorage.getItem('billingId'));
    xstore = sessionStorage.getItem('xstore');
    auxBillingId = Number(sessionStorage.getItem('auxBillingId'));
    clientInfoVO: ClientInfoVO;

    ituArray: Itu[] = [];
    validaItu: ValidaItuInterface;
    ituSendArray: string[] = [];
    ituSeriesArray: string[] = [];

    key = '';
    state = '';

    resetForm = false;

    verFactura = '';

    inputCFDI = false;
    disabledReFiscal = false;

    conDomicilio: boolean;

    email: string;
    display =  true;
    puedeSalir = false;
    inputName = false;
    inputPaternal = false;
    inputMaternal = false;
    btnSwitch = false;
    inputColony = true;
    title = false;
    titleOriginals = false;
    btnEdit = false;
    noPublicGen: string[] = ['PUBLICOENGENERAL', 'PÚBLICOENGENERAL', 'VENTAALPUBLICOENGENERAL', 'VENTAALPÚBLICOENGENERAL', 'VENTAGENERALPUBLICO', 'PUBLICOGENERAL', 'PÚBLICOGENERAL', 'VENTAPUBLICOGENERAL', 'VENTAPÚBLICOGENERAL'
        , 'PUBLICO EN GENERAL', 'PÚBLICO EN GENERAL', 'VENTA AL PUBLICO EN GENERAL', 'VENTA AL PÚBLICO EN GENERAL', 'VENTA AL PUBLICO EN GENERAL', 'VENTAAL PUBLICO EN GENERAL'];

    // tableRfc
    constructor(private fb: FormBuilder,
                private tipoSelect: TipoSelectService,
                private spinnerService: NgxSpinnerService,
                private router: Router,
                config: NgbModalConfig,
                private modalService: NgbModal,
                private configService: AppConfigService,
                private generaItuService: GeneraItuService,
                private addressService: AddressService,
                private emailService: UserEmailService) {
        this.colorTexto = this.configService.getConfig().colorTexto;
        this.classBtn = this.configService.getConfig().classBtn;
        config.backdrop = 'static';
        config.keyboard = false;
        this.formSinData();
        /*
        this.tipoSelect.getState().subscribe((data: SelectGeneric) => {
          this.estados = data.object;
        });
        */
        this.createFormInvoice();
    }

    async canDeactivate(): Promise<boolean> {
        const result = await swal({
            text: 'Se cancelará el proceso de Facturación. ¿Desea continuar?',
            type: 'question',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: this.colorTexto,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, estoy seguro'
        });
        if (result.value) {
            console.log('-------------- SALIENDO... --------------');
            await this.reiniciarProceso(true);
        }
        return result.value;
    }

    bloquearCaracteresEspeciales(event: KeyboardEvent): void {
        const regex = /^[a-zA-Z0-9]*$/; // permite letras y números
        const inputChar = event.key;
        if (!regex.test(inputChar)) {
            event.preventDefault(); // bloquea el caracter
        }
    }

    bloquearCaracteresEspecialesYLetras(event: KeyboardEvent): void {
        const regex = /^[0-9]*$/; // números
        const inputChar = event.key;
        if (!regex.test(inputChar)) {
            event.preventDefault(); // bloquea el caracter
        }
    }

    ngOnInit() {
        this.email = localStorage.getItem('userEmail');
        console.log('userEmail:', this.email);

        this.initializeForm();
    }

    agregarDomicilio() {
        this.conDomicilio = !this.conDomicilio; // Cambia el estado del toggle

        // Opcional: Si necesitas resetear campos al ocultar la sección
        if (!this.conDomicilio) {
            this.resetDomicilioFields();
        } else {
            this.formInvoice.get('street').enable();
            this.formInvoice.get('outerNumber').enable();
            this.formInvoice.get('innerNumber').enable();
            this.formInvoice.get('state').enable();
            this.formInvoice.get('municipality').enable();
            this.formInvoice.get('colony').enable();
        }
    }

    resetDomicilioFields() {
        this.formInvoice.patchValue({
            street: '',
            outerNumber: '',
            innerNumber: '',
            state: '',
            municipality: '',
            colony: ''
        });
    }

    initializeForm() {
        const ONLY_LETTERS_REGEX = /^[A-Za-zÑñÁÉÍÓÚáéíóúÜü\s]+$/;
        this.formInvoice = this.fb.group({

            rfc: [
                {value: '', disabled: true},
                [
                    Validators.required,
                    Validators.pattern(/^([A-ZÑ&]{3,4})\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z\d]{3}$/i),
                    Validators.maxLength(13)
                ]
            ],
            type: new FormControl({value: '', disabled: false}, Validators.required),
            zipCode: new FormControl({value: '', disabled: true}, Validators.required),
            regimenFiscal: new FormControl({value: null, disabled: true}, Validators.required),
            useCfdi: new FormControl({value: null, disabled: true}, Validators.required),
            name: new FormControl({
                value: '',
                disabled: true
            }, [Validators.required]),
            paternalSurname: new FormControl({
                value: '',
                disabled: true
            }, [Validators.required]),
            maternalSurname: new FormControl({
                value: '',
                disabled: true
            }, [Validators.required]),
            email: new FormControl({value: '', disabled: true}, Validators.required),

            fiscalResidence: new FormControl({value: '', disabled: false}),
            nacional: new FormControl({value: '', disabled: false}),
            numRegId: new FormControl({value: '', disabled: false}),
            solounico: new FormControl({value: '', disabled: false}),
            idTransaction: new FormControl({value: '', disabled: false}),
            iepsRequired: new FormControl({value: '', disabled: false}),

            street: new FormControl(''),
            outerNumber: new FormControl(''),
            innerNumber: new FormControl(''),
            state: new FormControl(''),
            municipality: new FormControl(''),
            colony: new FormControl('')

        });

        if (!this.conDomicilio) {
            this.resetDomicilioFields();
        }

    }

    private markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();
            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }

    createFormInvoice() {
        console.log('ENTRO EN createFormInvoice');
        const clienteSeleccionado = this.addressService.getAddress(); // Obtiene los datos del servicio

        if (clienteSeleccionado) {
            console.log('clienteSeleccionado');
            this.formSinData();
        }

        this.clientInfoVO = {rfc: sessionStorage.getItem('rfc')};

        if (this.clientInfoVO.rfc === 'XAXX010101000' || this.clientInfoVO.rfc === 'XEXX010101000') {

            this.cpByItu = {itu: sessionStorage.getItem('itu'), rfc: this.clientInfoVO.rfc};
            this.tipoSelect.getCpByItu(this.cpByItu).subscribe((data: Person) => {
                if (data.object !== null) {
                    console.log('DATA: ', data.object.state);

                    // Como el estado viene con mayusculas desde la BD, Lo pasamos en Minuculas y lo pasamos la primera en mayusculas.
                    data.object.state = this.formatearTexto(data.object.state);

                    if (!data.status) {
                        swal('Error!', data.msg, 'error');

                    } else {
                        // tslint:disable-next-line:no-shadowed-variable
                        this.tipoSelect.getTipoPersona().subscribe((data: SelectGeneric) => {
                            console.log('DATA: ', data);

                            if (data !== null) {
                                this.arrPerson = data.object;
                            }
                        });

                        if (data.object.type !== null) {
                            this.dataInvoice = data.object;

                            console.log('DATO - ' + this.dataInvoice);


                            this.getStateZipCode(this.dataInvoice.zipCode);
                            this.getMunicipalityZipCode(this.dataInvoice.zipCode);
                            this.getSuburbZipCode(this.dataInvoice.zipCode);

                            console.log('paso consultas de estados antes de consulta persona');

                            // his.getRegimenFiscal(tPersona: FormGroup);
                            this.formConData();
                        } else {

                            this.formSinData();
                        }
                    }

                } else {
                    swal('¡Advertencia!', 'La tienda no fue localizada. Ponte en contacto con los datos que aparecen al inicio de esta página.', 'warning');
                    this.rebootProcessNotFoundAddress();
                }
            });
        } else {

            this.tipoSelect.getClient(this.clientInfoVO).subscribe((data: Person) => {
                console.log('Datos cliente: ', data.object);
                if (!data.status) {
                    swal('Error!', data.msg, 'error');
                } else {
                    // tslint:disable-next-line:no-shadowed-variable
                    this.tipoSelect.getTipoPersona().subscribe((data: SelectGeneric) => {
                        console.log('DATA: ', data);
                        if (data !== null) {
                            this.arrPerson = data.object;
                        }
                    });
                    if (data.object.type !== null) {
                        this.dataInvoice = data.object;
                        console.log('Datos cliente en dataInvoice - ', this.dataInvoice);


                        this.getStateZipCode(this.dataInvoice.zipCode);
                        this.getMunicipalityZipCode(this.dataInvoice.zipCode);
                        this.getSuburbZipCode(this.dataInvoice.zipCode);

                        console.log('paso consultas de estados antes de consulta persona');


                        // his.getRegimenFiscal(tPersona: FormGroup);
                        this.formConData();
                    } else {

                        this.formSinData();
                    }
                }
            });
        }
    }

    mayus(e) {
        e.value = e.value.toUpperCase();
    }

    formConData() {

        this.disabledSelect = true;
        this.enableForm = true;
        this.btnAvailable = true;

        console.log('DATO - ', this.dataInvoice.state);
        console.log('DATO - ', this.dataInvoice.municipality);
        console.log('DATO - ', this.dataInvoice.colony);

        this.state = this.dataInvoice.state;
        /* this.getMunicipality(this.dataInvoice.idState, this.dataInvoice.state);
        this.getSuburb(this.dataInvoice.idMunicipality, this.dataInvoice.municipality);
        this.formInvoice.get('colony').setValue(this.dataInvoice.colony);
        this.formInvoice.get('state').setValue(this.dataInvoice.state);
        this.formInvoice.get('municipality').setValue(this.dataInvoice.municipality); */

        this.formInvoice.get('state').setValue(this.dataInvoice.state);

        console.log('Valor Asignado: ---> ', this.formInvoice.get('state').value);

        if (this.dataInvoice.nacional === 'S' || this.dataInvoice.nacional.trim() === '') {

            this.extranjero = false;
            this.dataInvoice.fiscalResidence = '';
            this.dataInvoice.numRegId = '';

        } else {

            this.extranjero = true;
            this.getResidenciaFisc();

            if (this.dataInvoice.fiscalResidence === '' || this.dataInvoice.fiscalResidence === null) {

                this.key = '';
                this.formInvoice.get('fiscalResidence').setValue(this.key);

            } else {

                this.key = this.dataInvoice.fiscalResidence.substr(0, 3);
                this.formInvoice.get('fiscalResidence').setValue(this.key);

            }
        }

        console.log('PASANDO');
        console.log('zipCode ', this.dataInvoice.zipCode);

        this.dataInvoice.iepsRequired = 'N';
        this.formInvoice.patchValue({

            iepsRequired: this.dataInvoice.iepsRequired,
            rfc: this.rfc_l.trim().toUpperCase(),
            type: this.type_p_l,
            name: this.dataInvoice.name,
            paternalSurname: this.dataInvoice.paternalSurname,
            maternalSurname: this.dataInvoice.maternalSurname,
            email: this.dataInvoice.email,
            zipCode: this.dataInvoice.zipCode,
            useCfdi: this.uso_c_l,
            regimenFiscal: this.reg_fis,
            nacional: this.dataInvoice.nacional,
            numRegId: this.dataInvoice.numRegId,
            fiscalResidence: this.key,
            solounico: this.key,
            idTransaction: this.billingId

        });

        console.log('formInvoice ---->', this.formInvoice);

        console.log('-----> ', this.formInvoice.get('state').value);

        if (this.dataInvoice.rfc.trim().toUpperCase() === 'XAXX010101000' || this.dataInvoice.rfc.trim().toUpperCase() === 'XEXX010101000') {

            this.formInvoice.get('type').disable();
            this.inputName = true;
            this.inputPaternal = false;
            this.inputMaternal = false;
            this.btnEdit = true;
            this.inputCFDI = true;
            this.disabledReFiscal = true;
            this.btnSwitch = true;
            this.disabledSelectPerson = true;
            this.inputColony = false; // Mantenerla apagada

            this.formInvoice.get('name').setValue('');
            this.formInvoice.get('paternalSurname').setValue('');
            this.formInvoice.get('maternalSurname').setValue('');

            this.formInvoice.get('name').enable();
            this.formInvoice.get('paternalSurname').enable();
            this.formInvoice.get('maternalSurname').enable();

            this.formInvoice.get('email').setValue('');
            this.formInvoice.get('email').enable();

            this.formInvoice.get('colonyText').setValue('');
        }
        // this.formInvoice.get('state').disable();
        // this.formInvoice.controls['state'].disable();
        // this.formInvoice.controls['state'].disable();
        // this.disabledState = true;
        /*
        this.formInvoice.controls['state'].disable();
        this.formInvoice.controls['municipality'].disable();
        */
        // this.formInvoice.disable();
        console.log('PASANDO 1 ' + this.extranjero);
        // this.formInvoice.disable();
    }

    formSinData() {

        console.log('entro en formSinData');
        console.log('dataInvoice', this.dataInvoice);


        const clienteSeleccionado = this.addressService.getAddress(); // Obtiene los datos del servicio

        if (clienteSeleccionado) {
            console.log('clienteSeleccionado', clienteSeleccionado);

            this.tipoSelect.getRegimenFiscalList(clienteSeleccionado.busnessActivity).subscribe((data1: SelectGeneric) => {
                console.log('getRegimenFiscalList: ', data1);
                this.arrRegimenFi = data1.object;
            });

            console.log('busnessActivity ', clienteSeleccionado.busnessActivity);
            this.tipouso = {
                regFiscalId: clienteSeleccionado.regimenFiscal,
                typePerson: clienteSeleccionado.busnessActivity
            };

            console.log('tipouso ', this.tipouso);
            this.tipoSelect.getUsageTypeList(this.tipouso).subscribe((data2: SelectGeneric) => {
                console.log('getUsageTypeList: ', data2);
                this.arrTipoUso = data2.object;
            });

            console.log('arrTipoUso ', this.arrTipoUso);

            this.getResidenciaFisc();
            this.disabledSelect = false;
            this.btnAvailable = false;

            this.formInvoice = this.fb.group({
                iepsRequired: new FormControl({value: 'N', disabled: true}),
                rfc: new FormControl({value: clienteSeleccionado.rfc, disabled: true}),
                type: new FormControl({value: clienteSeleccionado.busnessActivity, disabled: true}),
                name: new FormControl({value: clienteSeleccionado.firstName, disabled: true}),
                paternalSurname: new FormControl({value: clienteSeleccionado.middleName, disabled: true}),
                maternalSurname: new FormControl({
                    value: clienteSeleccionado.lastName.toString() || '',
                    disabled: true
                }),
                email: new FormControl({value: this.email, disabled: true}),
                zipCode: new FormControl({value: clienteSeleccionado.postalCodeBilling, disabled: true}),
                useCfdi: [this.uso_c_l],
                regimenFiscal: [this.reg_fis],
                idTransaction: [this.billingId],
            });

            this.enableForm = true;

            console.log('formInvoice ---->', this.formInvoice);

        } else {

            this.tipoSelect.getRegimenFiscalList(this.type_p_l).subscribe((data1: SelectGeneric) => {
                console.log('DATA: ', data1);
                this.arrRegimenFi = data1.object;
            });

            this.tipouso = {regFiscalId: this.reg_fis, typePerson: this.type_p_l};

            this.tipoSelect.getUsageTypeList(this.tipouso).subscribe((data2: SelectGeneric) => {
                console.log('DATA: ', data2);
                this.arrTipoUso = data2.object;
            });

            this.getResidenciaFisc();
            this.disabledSelect = false;
            this.btnAvailable = false;

            this.formInvoice = this.fb.group({
                iepsRequired: ['N'],
                rfc: [this.rfc_l.toUpperCase()],
                type: [this.type_p_l],
                name: [''],
                paternalSurname: [''],
                maternalSurname: [''],
                email: [''],
                street: [''],
                outerNumber: [''],
                innerNumber: [''],
                zipCode: [''],
                colony: [''],
                colonyText: [''],
                nocolony: [''],
                /*  idState: [''],*/
                state: [''],
                /*idCity: [''],
                  city: [''],
                  idMunicipality: [''],  */
                municipality: [''],
                useCfdi: [this.uso_c_l],
                regimenFiscal: [this.reg_fis],
                nacional: ['S'],
                numRegId: [''],
                fiscalResidence: [''],
                solounico: [''],
                idTransaction: [this.billingId],
            });

        }

        if (this.type_p_l === 'M') {

            this.formInvoice.get('paternalSurname').disable();
            this.formInvoice.get('maternalSurname').disable();
            this.formInvoice.get('paternalSurname').setValue('');
            this.formInvoice.get('maternalSurname').setValue('');
        } else {
            this.formInvoice.get('paternalSurname').enable();
            this.formInvoice.get('maternalSurname').enable();
        }


    }

    getRegimenFiscal(tPersona: FormGroup) {
        this.type_p_l = tPersona.controls['type'].value;

        this.tipoSelect.getRegimenFiscalList(this.type_p_l).subscribe((data1: SelectGeneric) => {
            console.log('DATA: ', data1);
            this.arrRegimenFi = data1.object;
        });

        if (this.type_p_l === 'M') {

            this.formInvoice.get('paternalSurname').disable();
            this.formInvoice.get('maternalSurname').disable();
            this.formInvoice.get('paternalSurname').setValue('');
            this.formInvoice.get('maternalSurname').setValue('');

            this.formInvoice.get('zipCode').setValue('');
            this.formInvoice.get('regimenFiscal').setValue('');
            this.formInvoice.get('useCfdi').setValue('');
            this.formInvoice.get('email').setValue('');
            this.formInvoice.get('rfc').setValue('');
            this.formInvoice.get('name').setValue('');
        } else {
            this.formInvoice.get('paternalSurname').enable();
            this.formInvoice.get('maternalSurname').enable();

            this.formInvoice.get('zipCode').setValue('');
            this.formInvoice.get('regimenFiscal').setValue('');
            this.formInvoice.get('useCfdi').setValue('');
            this.formInvoice.get('email').setValue('');
            this.formInvoice.get('rfc').setValue('');
            this.formInvoice.get('name').setValue('');

        }

    }

    // Se modifica getTipoUso para recibir regFiscalId y typePerson
    getTipoUso(tRegimen: FormGroup) {
        console.log('entro aqui ', tRegimen.controls);

        console.log('entro  ', tRegimen.controls['regimenFiscal'].value);
        this.tipouso = {regFiscalId: tRegimen.controls['regimenFiscal'].value, typePerson: this.type_p_l};
        this.tipoSelect.getUsageTypeList(this.tipouso).subscribe((data2: SelectGeneric) => {
            console.log('DATA: ', data2);
            this.arrTipoUso = data2.object;
        });
    }

    getResidenciaFisc() {
        this.tipoSelect.getResidenciasFiscales().subscribe((data: SelectGeneric) => {
            console.log('getResidenciasFiscales: ', data);
            if (!data.status) {
                swal('Error!', data.msg, 'error');
            } else {
                this.residenciasFiscales = data.object;
            }
        });
    }

    // Activa campos del formulario para poder editarlos
    enableField() {

        this.formInvoice.enable();
        console.log('érpsna enable ', this.type_p_l);

        if (this.type_p_l === 'M') {

            this.formInvoice.get('paternalSurname').disable();
            this.formInvoice.get('maternalSurname').disable();
            this.formInvoice.get('paternalSurname').setValue('');
            this.formInvoice.get('maternalSurname').setValue('');
        } else {
            this.formInvoice.get('paternalSurname').enable();
            this.formInvoice.get('maternalSurname').enable();
        }


    }

    onChangeIEPS() {
        if (this.changeIeps) {
            this.changeIeps = false;
            this.formInvoice.get('iepsRequired').setValue('N');
        } else {
            this.changeIeps = true;
            this.formInvoice.get('iepsRequired').setValue('S');

        }
    }

    onChangeForeign() {
        this.extranjero = !this.extranjero; // Invierte el estado del toggle

        this.formInvoice.get('nacional').setValue(this.extranjero ? 'N' : 'S');

        if (!this.extranjero) {
            this.formInvoice.patchValue({
                fiscalResidence: '',
                numRegId: ''
            });
        }
    }

    getMunicipalityZipCode(zipCode) {
        this.tipoSelect.getMunicipality(zipCode).subscribe((data: SelectGeneric) => {
            console.log('DATA: ', data);
            this.municipios = data.object;
        });
    }

    getMunicipality(id, value) {
        this.formInvoice.get('state').setValue(value);
        if (id === '0') {

            console.log('value ', value);
            id = value;
        }
        this.tipoSelect.getMunicipality(id).subscribe((data: SelectGeneric) => {
            console.log('DATA: ', data);
            this.municipios = data.object;
        });
    }

    getStateZipCode(zipCode) {
        this.tipoSelect.getStateZipCode(zipCode).subscribe((data: SelectGeneric) => {
            this.estados = data.object;
        });
    }

    getSuburbZipCode(zipCode) {
        this.tipoSelect.getSuburb(zipCode).subscribe((data: SelectGeneric) => {
            console.log('DATA: ', data);
            this.colonias = data.object;
        });
    }

    getSuburb(id, value) {
        this.formInvoice.get('municipality').setValue(value);
        if (id === '0') {

            console.log('getSuburb value ', value);
            id = value;
        }

        this.tipoSelect.getSuburb(id).subscribe((data: SelectGeneric) => {
            console.log('DATA: ', data);
            this.colonias = data.object;
        });
    }

    openBottomSheet(formInvoice: FormGroup, content): void {
        this.formInvoice.enable();

        this.markFormGroupTouched(formInvoice);

        if (!formInvoice.valid) {
            this.spinnerService.hide();
            swal('Advertencia', 'Por favor llene todos los campos obligatorios.', 'warning');
            return;
        }

        const nameFull =
            this.formInvoice.get('name').value +
            '' +
            this.formInvoice.get('paternalSurname').value.trim().replace(' ', '') +
            '' +
            this.formInvoice.get('maternalSurname').value.trim().replace(' ', '');

        console.log(this.formInvoice);
        console.log('iepsRequired: ', this.formInvoice.controls['iepsRequired'].value);

        this.spinnerService.show();
        this.dataInvoice = formInvoice.value;

        this.dataInvoice.idTransactionAux = this.auxBillingId.toString();
        this.dataInvoice.email = this.dataInvoice.email.trim().toUpperCase();
        this.dataInvoice.xstore = this.xstore;
        console.log('xstore', this.xstore);

        if (this.dataInvoice.type === 'F') {
            this.consultaRFC = {
                businessName: `${this.dataInvoice.name} ${this.dataInvoice.paternalSurname} ${this.dataInvoice.maternalSurname}`.trim(),
                postalCode: this.dataInvoice.zipCode,
                regimenFiscal: this.dataInvoice.regimenFiscal,
                rfc: this.dataInvoice.rfc.trim().toUpperCase()
            };
        } else {
            this.consultaRFC = {
                businessName: this.dataInvoice.name.trim(),
                postalCode: this.dataInvoice.zipCode,
                regimenFiscal: this.dataInvoice.regimenFiscal,
                rfc: this.dataInvoice.rfc.trim().toUpperCase()
            };
        }

        const rfcFieldValue = this.formInvoice.get('rfc').value;

        if (rfcFieldValue === 'XAXX010101000' || this.dataInvoice.rfc.trim().toUpperCase() === 'XEXX010101000') {
            if (this.formInvoice.get('name').value === '' || rfcFieldValue.length <= 3) {
                swal('Advertencia', '¡Debes de llenar correctamente el campo Nombre', 'warning');
                return;
            }

            if (this.formInvoice.get('paternalSurname').value === '') {
                this.formInvoice.get('paternalSurname').setValue(' ');
            }

            if (this.formInvoice.get('maternalSurname').value === '') {
                this.formInvoice.get('maternalSurname').setValue(' ');
            }
        }

        if (this.getWordsIncorrect(nameFull)) {
            this.spinnerService.hide();
            swal('¡Advertencia!', 'Para facturar a RFC genérico debe de colocar un nombre o razón social.', 'warning');
            return;
        }

        console.log('Estamos por validar si es extranjero', formInvoice.value);
        this.validateForeignData();

        if (!this.validForeingData) {
            return;
        }

        const handleSuccess = (data: EmitResultInterface) => {
            if (data.object.errorMsg === '') {
                this.spinnerService.hide();
                sessionStorage.clear();
                sessionStorage.setItem('consultRfc', this.rfc_l.trim().toUpperCase());
                this.verFactura = data.object.newItu;
                this.modalService.open(content);
            } else {
                this.spinnerService.hide();
                swal('', data.object.errorMsg, 'error');
            }
        };

        const handleError = (err: any) => {
            console.error(err);
            this.spinnerService.hide();
            this.resetForm = true;
            swal('Error', 'Error al conectar con el Servidor', 'error');
        };

        if (this.dataInvoice.rfc.trim().toUpperCase() === 'XAXX010101000' || this.dataInvoice.rfc.trim().toUpperCase() === 'XEXX010101000') {
            this.tipoSelect.sendInvoice(this.dataInvoice).subscribe(handleSuccess, handleError);
        } else {
            this.tipoSelect.validaRFC(this.consultaRFC).subscribe(
                (data: ResponseString) => {
                    if (data.status) {
                        this.tipoSelect.sendInvoice(this.dataInvoice).subscribe(handleSuccess, handleError);
                    } else {
                        if (
                            data.msg.toLowerCase().includes('xml mal formado') ||
                            data.msg.toLowerCase().includes('object reference not set to an instance of an object')
                        ) {
                            this.spinnerService.hide();
                            swal('Error', 'El RFC ingresado no es válido. Verifica que tenga el formato correcto (letras, fecha y homoclave).', 'error');
                        } else {
                            // Mensaje genérico para otros errores
                            this.spinnerService.hide();
                            swal('Error', data.msg, 'error');
                        }
                    }
                },
                err => {
                    console.error(err);
                    this.spinnerService.hide();
                    swal('Error', 'Error al conectar con el servidor', 'error');
                }
            );
        }
    }


    verFact() {
        this.modalService.dismissAll();
        this.puedeSalir = true;
        this.router.navigate(['/home']);
    }

    getList() {
        const code = this.formInvoice.get('zipCode').value;
        // console.log(code.length);
        if (code.length === 5) {
            console.log(' YA ESTA ');
            this.getStateZipCode(code);
            this.getMunicipalityZipCode(code);
            this.getSuburbZipCode(code);

        }
    }

    // Habilita colonoa en texto

    completeItem() {

        if (this.nocolony) {
            this.nocolony = false;
            this.formInvoice.get('colony').enable();
            this.formInvoice.get('colonyText').disable();
        } else {
            this.nocolony = true;
            this.formInvoice.get('colony').disable();
            this.formInvoice.get('colonyText').enable();

        }

    }

    // Reinicia el proceso de Genera Factura
    async reiniciarProceso(isCanDeactivate: boolean) {
        let confirmar = true;

        if (!isCanDeactivate) {
            const result = await swal({
                text: 'Se cancelará el proceso de Facturación. ¿Desea continuar?',
                type: 'question',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: this.colorTexto,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, estoy seguro'
            });

            confirmar = result.value; // true si confirma, false si cancela
        }

        if (confirmar) {
            console.log(this.ituArray);
            console.log('billingId = ' + Number(sessionStorage.getItem('billingId')));
            this.ituSendArray[0] = sessionStorage.getItem('itu');

            this.validaItu = {
                billingId: Number(sessionStorage.getItem('billingId')),
                auxBillingId: Number(sessionStorage.getItem('auxBillingId')),
                itu: '', amount: 0, listItus: this.ituSendArray,
                xstore: sessionStorage.getItem('xstore'),
                series: this.ituSeriesArray = [sessionStorage.getItem('ituSerie')],
                totalItus: Number(sessionStorage.getItem('totalItu'))
            };

            this.generaItuService.releaseItus(this.validaItu).subscribe({
                next: (data: any) => {
                    console.log('DATA: ', data);
                    if (data['object'] === 'OK') {
                        this.router.navigate(['/home']);
                        sessionStorage.clear();
                    } else {
                        swal('Error', 'Error al conectar con el Servidor', 'error');
                    }
                },
                error: (err) => {
                    console.error(err);
                    this.spinnerService.hide();
                    swal('Error', 'Error al conectar con el Servidor', 'error');
                }
            });
        }
    }


    validateForeignData() {
        console.log(this.extranjero);
        console.log('fiscalResidence', this.dataInvoice.fiscalResidence);

        if (this.extranjero) {
            console.log(this.dataInvoice.fiscalResidence.trim());
            console.log(this.dataInvoice.numRegId.trim());
            if (this.dataInvoice.fiscalResidence.trim() === '' ||
                this.dataInvoice.numRegId.trim() === '') {
                this.validForeingData = false;
                swal('Advertencia', 'Sí la opción de extrajero está habilitada, debe llenar los campos Número de Registro y Residencia fiscal', 'warning');
            } else {
                this.validForeingData = true;
            }
        } else {
            this.validForeingData = true;
            this.dataInvoice.fiscalResidence = '';
            this.dataInvoice.numRegId = '';
        }
    }


    rebootProcessNotFoundAddress() {
        console.log(this.ituArray);
        console.log('billingId = ' + Number(sessionStorage.getItem('billingId')));
        this.ituSendArray[0] = sessionStorage.getItem('itu');

        this.validaItu = {
            billingId: Number(sessionStorage.getItem('billingId')),
            auxBillingId: Number(sessionStorage.getItem('auxBillingId')),
            itu: '', amount: 0, listItus: this.ituSendArray,
            xstore: sessionStorage.getItem('xstore'),
            series: this.ituSeriesArray = [sessionStorage.getItem('ituSerie')],
            totalItus: Number(sessionStorage.getItem('totalItu'))
        };

        this.generaItuService.releaseItus(this.validaItu).subscribe((data: object) => {
            console.log('DATA: ', data);
            if (data != null) {
                if (data['object'] === 'OK') {
                    this.router.navigate(['/generaF']);
                    sessionStorage.clear();
                } else {
                    swal('Error', 'Error al conectar con el Servidor', 'error');
                }
            } else {
                swal('Error', 'Error al conectar con el Servidor', 'error');
            }

        }, err => {
            console.error(err);
            this.spinnerService.hide();
            swal('Error', 'Error al conectar con el Servidor', 'error');
        });
    }

    getWordsIncorrect(nameFull: string): boolean {
        return this.noPublicGen.some((value) => value.toUpperCase() === nameFull.toUpperCase());
    }

    formatearTexto(texto: string): string {
        // Convertir todo el texto a minúsculas y luego hacer título cada palabra
        if (texto.toUpperCase() === 'CIUDAD DE MEXICO') {
            return 'Ciudad de México';
        }

        if (texto.toUpperCase() === 'ESTADO DE MEXICO') {
            return 'Estado de México';
        }
        return texto
            .toLowerCase()
            .split(' ')
            .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(' ');
    }
}
